export default "__VITE_ASSET__CBXx$rKB__"